import request from "../utils/request";

export const getProductQrs = '/product/qr/'


export function importProductionQr(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/product/qr/',
        method: 'post',
        data: formData
    })
}

export function modifyProductQr(data: any) {
    return request.request({
        url: '/product/qr/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteProductQrs(ids: number[]) {
    return request.request({
        url: '/product/qr/',
        method: 'delete',
        params: {ids: ids.join(",")}
    })
}
